import { styled } from '@mui/material/styles';
import { CSSProperties, FC, memo, ReactNode } from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';

interface ScrollbarProps {
  className?: string;
  children?: ReactNode;
  style?: CSSProperties;
}

// simplebar のサム(.simplebar-scrollbar::before)を現行の MUI theme 連動装飾で再現する。
// 旧ライブラリ時代は width:5 / alpha.black[10] / hover alpha.black[30] / borderRadiusLg だった。
const StyledSimpleBar = styled(SimpleBar)(({ theme }) => ({
  '& .simplebar-scrollbar::before': {
    width: 5,
    background: theme.colors.alpha.black[10],
    borderRadius: theme.general.borderRadiusLg,
    transition: theme.transitions.create(['background']),
  },
  '& .simplebar-scrollbar.simplebar-hover::before, & .simplebar-scrollbar:hover::before': {
    background: theme.colors.alpha.black[30],
  },
}));

// 旧ライブラリは内部コンテナへ width/height 100% を既定適用していた。
// style 未指定の呼び出し側(V2/V3 OrdersPresenter)で高さが潰れないよう既定サイズを与え、
// 呼び出し側の style（例: PlanningTrucks の height:calc(...)）で上書きできるようにする。
const Scrollbar: FC<ScrollbarProps> = memo(({ className, children, style, ...rest }) => (
  <StyledSimpleBar
    autoHide
    className={className}
    style={{ width: '100%', height: '100%', ...style }}
    {...rest}
  >
    {children}
  </StyledSimpleBar>
));

export default Scrollbar;
